import { NewPeriod } from '@app/models/period';
import api from '@services/api';

import { PaginationResponse } from '../models/pagination';
import {
  ProcessRequest,
  TeacherPaymentRequest,
  TeacherPaymentResponse,
} from '../models/teacherPayment';

/**
 * <p>
 * API endpoints that cover all resource teacherPayment related CRUD calls
 */
export const TeacherPaymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // POST
    TeacherPaymentFile: builder.mutation<PaginationResponse<NewPeriod>, ProcessRequest>({
      query: (input: ProcessRequest) => ({
        url: encodeURI(`/school/payment/upload?periodDate=${input.periodDate}`),
        method: 'POST',
        body: input.body,
      }),
      invalidatesTags: ['TeacherPaymentResponse', 'Periods'],
    }),
    // GET
    TeacherPaymentResponse: builder.query<
      PaginationResponse<TeacherPaymentResponse>,
      TeacherPaymentRequest
    >({
      query: (request) => ({
        url: encodeURI(
          `/school/payment/search?${
            request.searchTerm ? `searchTerm=${request.searchTerm}&` : ''
          }periodDate=${request.periodDate}&page=${request.page}&size=${request.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['TeacherPaymentResponse'],
    }),
  }),
});

export const { useTeacherPaymentFileMutation, useTeacherPaymentResponseQuery } = TeacherPaymentApi;
